const data = {
  development: {
    contentfulUrl: 'https://preview.contentful.com',
    contentfulSpaceId: 'z0gfrn2oe8aa',
    contentfulToken: '4173577306863b4340664af57c56b43fe0421c535449cd4fa8479a8da9a31163',
    stripePublicKey: 'pk_test_abug0EC6PPWhOwZ0e3qzMQma',
  },
  production: {
    contentfulUrl: 'https://cdn.contentful.com',
    contentfulSpaceId: 'z0gfrn2oe8aa',
    contentfulToken: '3a25c627ac08efd24a171e522755576fbcd5391bf8a51a27feec040c51fe9c8e',
    stripePublicKey: 'pk_live_Uk34IAoGzAjqdmS45YwWjHJR',
  },
  staging: {
    contentfulUrl: 'https://preview.contentful.com',
    contentfulSpaceId: 'z0gfrn2oe8aa',
    contentfulToken: '4173577306863b4340664af57c56b43fe0421c535449cd4fa8479a8da9a31163',
    stripePublicKey: 'pk_test_abug0EC6PPWhOwZ0e3qzMQma',
  },
}

module.exports = data[window.GLOBAL_ENV.API_TYPE]



// WEBPACK FOOTER //
// ./src/config/other.js